import { DinamicComponents } from 'scorpion-core'
import FluxoKamban from "./components/FluxoKamban";
import Comentarios from "./components/Comentarios";
import Anexos from "./components/Anexos";
import ComboxItens from "./components/ComboxItens";
import SeletorCustomForm from "./components/SeletorCustomForm";
import TabelaItensCustomForm from "./components/TabelaItensCustomForm";
import ViewInputLogico from "./components/ViewInputLogico";
import AtribuirPerfil from "./components/AtribuirPerfil";
import ConsultaPersonalisada from "./components/ConsultaPersonalisada";
import Historico from "./components/Historico";
import HistoricoField from "./components/HistoricoField";
import Gant from "./components/Gant";
import PesquisaItensCustomForm from "./components/PesquisaItensCustomForm";
import ListCustomFormFiltros from "./components/ListCustomFormFiltros";
import GantListaFiltrada from "./components/GantListaFiltrada";
import Tags from "./components/Tags";

function configDinamicComponenets() {
    DinamicComponents.addComponente(FluxoKamban)
    DinamicComponents.addComponente(Comentarios)
    DinamicComponents.addComponente(Anexos)

    DinamicComponents.addComponente(ComboxItens)
    DinamicComponents.addComponente(SeletorCustomForm)
    DinamicComponents.addComponente(TabelaItensCustomForm)
    DinamicComponents.addComponente(ViewInputLogico)
    DinamicComponents.addComponente(AtribuirPerfil)
    DinamicComponents.addComponente(ConsultaPersonalisada)
    DinamicComponents.addComponente(Historico)
    DinamicComponents.addComponente(HistoricoField)
    DinamicComponents.addComponente(Gant)
    DinamicComponents.addComponente(PesquisaItensCustomForm)
    DinamicComponents.addComponente(ListCustomFormFiltros)
    DinamicComponents.addComponente(GantListaFiltrada)
    DinamicComponents.addComponente(Tags)
}

export default configDinamicComponenets


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/index.js